export enum BlockTypes {
  CodeContent = 'CodeContent',
  Heading = 'Heading',
  ListItem = 'ListItem',
  MiniHeadline = 'MiniHeadline',
  Paragraph = 'Paragraph',
  SubHeading = 'SubHeading',
  ThematicBreak = 'ThematicBreak',
  Unknown = 'Unknown'
}
